import { createElement } from "rlink-react";

export default function IconEssence(props) {
  return (
    <svg id="Layer_1" viewBox="0 0 203.92 211.94" {...props}>
      <g>
        <g>
          <g id="Final_Logomark_00000170970944987271516010000013462195862401315256_">
            <g id="Final_refinements_00000071530208496389826460000006830069812314894739_">
              <path
                fill="#FFFFFF"
                d="M92.99,109.04l5.43,3.13c2.19,1.27,4.89,1.27,7.08,0l57.26-33.06c4.72-2.73,4.72-9.54,0-12.27l-53.72-31.01
					c-4.38-2.53-9.79-2.53-14.17,0L37.62,68.89c-4.38,2.53-7.08,7.21-7.08,12.27l0,49.62c0,5.06,2.7,9.74,7.08,12.27l57.26,33.06
					c4.38,2.53,9.79,2.53,14.17,0l75.09-43.35c2.19-1.27,3.54-3.6,3.54-6.14v-6.27c0-2.73-2.95-4.43-5.31-3.07l-75.09,43.35
					c-3.29,1.9-7.34,1.9-10.63,0l-48.29-27.88c-2.19-1.27-3.54-3.6-3.54-6.14l0-39.26c0-3.8,2.03-7.31,5.31-9.2l46.52-26.86
					c3.29-1.9,7.34-1.9,10.63,0l32.23,18.61c2.36,1.36,2.36,4.77,0,6.14L92.99,102.9C90.63,104.27,90.63,107.68,92.99,109.04z"
              />
              <path
                fill="#FFFFFF"
                d="M105.5,66.78l5.43,3.13c2.36,1.36,2.36,4.77,0,6.14l-34,19.63c-2.19,1.27-3.54,3.6-3.54,6.14l0,10.36
					c0,1.27,0.68,2.44,1.77,3.07l23.26,13.43c2.19,1.27,4.89,1.27,7.08,0l76.86-44.37c3.29-1.9,5.31-5.41,5.31-9.2v-0.13
					c0-6.33-3.38-12.18-8.86-15.34l-68-39.26c-5.48-3.16-12.23-3.16-17.71,0l-68,39.26c-5.48,3.16-8.86,9.01-8.86,15.34l0,62.03
					c0,6.33,3.38,12.18,8.86,15.34l68,39.26c5.48,3.16,12.23,3.16,17.71,0l57.26-33.06c2.36-1.36,5.31,0.34,5.31,3.07v6.27
					c0,2.53-1.35,4.87-3.54,6.14l-57.26,33.06c-6.58,3.8-14.68,3.8-21.25,0L12.59,161.6c-6.58-3.8-10.63-10.81-10.63-18.41l0-74.43
					c0-7.59,4.05-14.61,10.63-18.41L91.33,4.89c6.58-3.8,14.68-3.8,21.25,0l78.75,45.46c6.58,3.8,10.63,10.81,10.63,18.41v8.45
					c0,7.59-4.05,14.61-10.63,18.41l-84.06,48.53c-3.29,1.9-7.34,1.9-10.63,0l-34-19.63c-2.19-1.27-3.54-3.6-3.54-6.14l0-22.77
					c0-3.8,2.03-7.31,5.31-9.2l34-19.63C100.61,65.51,103.31,65.51,105.5,66.78z"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/components/svg/iconEssence.jsx